module.exports = __webpack_public_path__ + "img/NYC_DOE.7ebd66e7.png";